import classNames from 'classnames'
import dynamic from 'next/dynamic'
import { useEffect, useState } from 'react'
import { useCookies } from 'react-cookie'

import Icon from '@/components/Icon/Icon'
import { useAds } from '@/contexts/ads'
import cookieService from '@/services/cookie.service'

import styles from './VideoAd.module.scss'

const ReactPlayer = dynamic(() => import('react-player'), { ssr: false })

const cookieKey = 'asteriClosed'
const maxAge = 300
const url = 'https://www.youtube.com/watch?v=jclO7Mjfjq0'

type Props = {
  showingAdhesion: boolean
}

const VideoAd = ({ showingAdhesion }: Props) => {
  const { loadAds } = useAds()

  const [cookies, _] = useCookies([cookieKey])
  const [isOpen, setIsOpen] = useState(false)

  const handleClose = () => {
    setIsOpen(false)
    cookieService.set(cookieKey, true, { maxAge })
    setTimeout(() => {
      setIsOpen(true)
      cookieService.remove(cookieKey)
    }, 1000 * maxAge)
  }

  useEffect(() => {
    setIsOpen(cookies[cookieKey] !== true)
  }, [])

  if (!isOpen) return null

  return (
    <div
      className={classNames(styles.container, {
        [styles.showingAdhesion]: showingAdhesion,
        'dev-ad': process.env.NODE_ENV !== 'production',
      })}
    >
      {loadAds === true && (
        <>
          <Icon className={styles.close} icon='timesCircle' onClick={handleClose} size='lg' />
          <ReactPlayer className={styles.player} height='180px' muted playing src={url} width='320px' />
        </>
      )}
    </div>
  )
}

export default VideoAd
